import { useEffect, useState } from "react";
import { listRegionApi, listMunicipalityApi, listProvinceApi, listComarcaApi, listCountryApi } from "../../../../services/Admin/geografia";

import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { set } from "date-fns";

export default function AssignedZones(props) {
    const {
        formik,
        showInfo,
        showZoneBlock,
    } = props

    // Listas de datos
    const [listCountry, setListCountry] = useState([]);
    const [listRegion, setListRegion] = useState([]);
    const [listProvince, setListProvince] = useState([]);
    const [listComarca, setListComarca] = useState([]);
    const [listMunicipality, setListMunicipality] = useState([]);

    // Estados para selección temporal y listas finales
    const [selectedCountry, setSelectedCountry] = useState("");
    const [selectedRegion, setSelectedRegion] = useState("");
    const [selectedProvince, setSelectedProvince] = useState("");
    const [selectedComarca, setSelectedComarca] = useState("");
    const [selectedMunicipality, setSelectedMunicipality] = useState("");

    // Listas finales seleccionadas
    const [countriesSelected, setCountriesSelected] = useState([]);
    const [regionsSelected, setRegionsSelected] = useState([]);
    const [provincesSelected, setProvincesSelected] = useState([]);
    const [comarcasSelected, setComarcasSelected] = useState([]);
    const [municipalitiesSelected, setMunicipalitiesSelected] = useState([]);

    // ### Obtencion de listas ###
    const getRegion = async () => {
        listRegionApi().then(resp => {
            const temp = resp.data.data
                .filter(doc => doc.isActive)
                .map((doc) => ({
                    id: doc.id,
                    ...doc,
                }))
            setListRegion(temp)
        })
    }

    const getProvince = async () => {
        listProvinceApi().then(resp => {
            const temp = resp.data.data
                .filter(doc => doc.isActive)
                .map((doc) => ({
                    id: doc.id,
                    ...doc,
                }))
            setListProvince(temp)
        })
    }

    const getComarca = async () => {
        listComarcaApi().then(resp => {
            const temp = resp.data.data
                .filter(doc => doc.isActive)
                .map((doc) => ({
                    id: doc.id,
                    ...doc,
                }))
            setListComarca(temp)
        })
    }

    const getCountry = async () => {
        listCountryApi().then(resp => {
            const temp = resp.data.data
                .filter(doc => doc.isActive)
                .map((doc) => ({
                    id: doc.id,
                    ...doc,
                }))
            setListCountry(temp)
        })
    }

    const getMunicipality = async () => {
        listMunicipalityApi().then(resp => {
            const temp = resp.data.data
                .filter(doc => doc.isActive)
                .map((doc) => ({
                    id: doc.id,
                    ...doc,
                }))
            setListMunicipality(temp)
        })
    }
    // ### END Obtencion de listas ###


    // ### Filtros ###
    const filteredCountry = listCountry.filter(c =>
        true
    );

    const filteredRegions = listRegion.filter(r =>
        countriesSelected.length === 0 ? true : countriesSelected.some(c => c.id === r.idCountry)
    );

    const filteredProvinces = listProvince.filter(p =>
        regionsSelected.length === 0 ? true : regionsSelected.some(r => r.id === p.idRegion)
    );

    const filteredComarca = listComarca.filter(c =>
        provincesSelected.length === 0 ? true : provincesSelected.some(p => p.id === c.idProvince)
    );

    // Filtrar municipios según provincias seleccionadas
    const filteredMunicipalities = listMunicipality.filter(m =>
        provincesSelected.length === 0 ? true : provincesSelected.some(p => p.id === m.idProvince)
    );
    // ### END Filtros ###

    // ### Añadir ###
    const handleAddCountry = () => {
        const country = filteredCountry.find(c => c.id === selectedCountry);
        if (country && !countriesSelected.some(c => c.id === country.id)) {
            setCountriesSelected([...countriesSelected, country]);
            setSelectedCountry("");
        }
    };

    const handleAddRegion = () => {
        const region = filteredRegions.find(r => r.id === selectedRegion);
        if (region && !regionsSelected.some(r => r.id === region.id)) {
            setRegionsSelected([...regionsSelected, region]);
            setSelectedRegion("");
        }
    };

    const handleAddProvince = () => {
        const province = filteredProvinces.find(p => p.id === selectedProvince);
        if (province && !provincesSelected.some(p => p.id === province.id)) {
            setProvincesSelected([...provincesSelected, province]);
            setSelectedProvince("");
        }
    };

    const handleAddComarca = () => {
        const comarca = filteredComarca.find(c => c.id === selectedComarca);
        if (comarca && !comarcasSelected.some(c => c.id === comarca.id)) {
            setComarcasSelected([...comarcasSelected, comarca]);
            setSelectedComarca("");
        }
    }

    const handleAddMunicipality = () => {
        const municipality = filteredMunicipalities.find(m => m.id === selectedMunicipality);
        if (municipality && !municipalitiesSelected.some(m => m.id === municipality.id)) {
            setMunicipalitiesSelected([...municipalitiesSelected, municipality]);
            setSelectedMunicipality("");
        }
    };
    // ### END Añadir ###

    // ### Eliminar ###
    const handleRemoveCountry = id => {
        // Eliminamos Pais
        const newCountriesSelected = countriesSelected.filter(c => c.id !== id);
        setCountriesSelected(newCountriesSelected);

        const newRegions = regionsSelected.filter(r => {
            const country = listCountry.find(c => c.id === r.idCountry);
            return country && country.id !== id;
        });
        setRegionsSelected(newRegions);

        const newProvinces = provincesSelected.filter(p => {
            const region = listRegion.find(r => r.id === p.idRegion);
            const country = region ? listCountry.find(c => c.id === region.idCountry) : null;
            return country && country.id !== id;
        });
        setProvincesSelected(newProvinces);

        const newComarcas = comarcasSelected.filter(c => {
            const province = listProvince.find(p => p.id === c.idProvince);
            const region = province ? listRegion.find(r => r.id === province.idRegion) : null;
            const country = region ? listCountry.find(c => c.id === region.idCountry) : null;
            return country && country.id !== id;
        });
        setComarcasSelected(newComarcas);

        const newMunicipalities = municipalitiesSelected.filter(m => {
            const province = listProvince.find(p => p.id === m.idProvince);
            const region = province ? listRegion.find(r => r.id === province.idRegion) : null;
            const country = region ? listCountry.find(c => c.id === region.idCountry) : null;
            return country && country.id !== id;
        });
        setMunicipalitiesSelected(newMunicipalities);

        // Actualiza formik
        formik.values.idCountry = newCountriesSelected;
    };

    const handleRemoveRegion = id => {
        const newRegions = regionsSelected.filter(r => r.id !== id);
        setRegionsSelected(newRegions);

        const newProvinces = provincesSelected.filter(p => {
            const region = listRegion.find(r => r.id === p.idRegion);
            return region && region.id !== id;
        });
        setProvincesSelected(newProvinces);

        const newComarcas = comarcasSelected.filter(c => {
            const province = listProvince.find(p => p.id === c.idProvince);
            const region = province ? listRegion.find(r => r.id === province.idRegion) : null;
            return region && region.id !== id;
        });
        setComarcasSelected(newComarcas);

        const newMunicipalities = municipalitiesSelected.filter(m => {
            const province = listProvince.find(p => p.id === m.idProvince);
            const region = province ? listRegion.find(r => r.id === province.idRegion) : null;
            return region && region.id !== id;
        });
        setMunicipalitiesSelected(newMunicipalities);
    };

    const handleRemoveProvince = id => {
        const newProvinces = provincesSelected.filter(p => {
            const region = listRegion.find(r => r.id === p.idRegion);
            const country = region ? listCountry.find(c => c.id === region.idCountry) : null;
            return country && country.id !== id;
        });
        setProvincesSelected(newProvinces);

        const newComarcas = comarcasSelected.filter(c => {
            const province = listProvince.find(p => p.id === c.idProvince);
            const region = province ? listRegion.find(r => r.id === province.idRegion) : null;
            const country = region ? listCountry.find(c => c.id === region.idCountry) : null;
            return country && country.id !== id;
        });
        setComarcasSelected(newComarcas);

        const newMunicipalities = municipalitiesSelected.filter(m => {
            const province = listProvince.find(p => p.id === m.idProvince);
            const region = province ? listRegion.find(r => r.id === province.idRegion) : null;
            const country = region ? listCountry.find(c => c.id === region.idCountry) : null;
            return country && country.id !== id;
        });
        setMunicipalitiesSelected(newMunicipalities);
    };

    const handleRemoveComarca = id => {
        const newComarcas = comarcasSelected.filter(c => {
            const province = listProvince.find(p => p.id === c.idProvince);
            const region = province ? listRegion.find(r => r.id === province.idRegion) : null;
            const country = region ? listCountry.find(c => c.id === region.idCountry) : null;
            return country && country.id !== id;
        });
        setComarcasSelected(newComarcas);

        const newMunicipalities = municipalitiesSelected.filter(m => {
            const province = listProvince.find(p => p.id === m.idProvince);
            const region = province ? listRegion.find(r => r.id === province.idRegion) : null;
            const country = region ? listCountry.find(c => c.id === region.idCountry) : null;
            return country && country.id !== id;
        });
        setMunicipalitiesSelected(newMunicipalities);
    };

    const handleRemoveMunicipality = id => setMunicipalitiesSelected(municipalitiesSelected.filter(m => m.id !== id));
    // ### END Eliminar ###

    // Actualizar formik con los valores seleccionados
    useEffect(() => {
        formik.values.idRegion = regionsSelected;
        formik.values.idProvince = provincesSelected;
        formik.values.idComarca = comarcasSelected;
        formik.values.idMunicipality = municipalitiesSelected;
        formik.values.idCountry = countriesSelected;
    }, [regionsSelected, provincesSelected, municipalitiesSelected, comarcasSelected, countriesSelected]); // eslint-disable-line

    useEffect(() => {
        // Inicializa los valores por defecto desde formik.values.idRegion, idProvince, idMunicipality
        if (
            Array.isArray(formik.values.idRegion) &&
            Array.isArray(formik.values.idProvince) &&
            Array.isArray(formik.values.idMunicipality) &&
            Array.isArray(formik.values.idComarca) &&
            Array.isArray(formik.values.idCountry) &&
            listRegion.length > 0 &&
            listProvince.length > 0 &&
            listMunicipality.length > 0 &&
            listCountry.length > 0 &&
            listComarca.length > 0
        ) {
            const defaultCountries = listCountry.filter(c => formik.values.idCountry.some(fc => fc.id === c.id));
            const defaultRegions = listRegion.filter(r => formik.values.idRegion.some(fr => fr.id === r.id));
            const defaultProvinces = listProvince.filter(p => formik.values.idProvince.some(fp => fp.id === p.id));
            const defaultComarcas = listComarca.filter(c => formik.values.idComarca.some(fc => fc.id === c.id));
            const defaultMunicipalities = listMunicipality.filter(m => formik.values.idMunicipality.some(fm => fm.id === m.id));

            // Sincroniza los selectores visuales
            setCountriesSelected(defaultCountries);
            setRegionsSelected(defaultRegions);
            setProvincesSelected(defaultProvinces);
            setComarcasSelected(defaultComarcas);
            setMunicipalitiesSelected(defaultMunicipalities);
        }
    }, [listRegion, listProvince, listMunicipality, listCountry, listComarca]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        getCountry()
        getRegion()
        getProvince()
        getComarca()
        getMunicipality()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            {showZoneBlock && (
                <Box border={1} className="p-20 mt-2 box-default">
                    <Grid container spacing={3}>
                        <Grid item md={6}>
                            <div style={{ gap: "10px", display: "flex", flexDirection: "column" }}>
                                <h3 className="p-0 mt-0">Zonas asignadas</h3>
                            </div>

                            {showInfo && (
                                <div style={{ marginTop: "10px" }}>
                                    <TextField
                                        name="info"
                                        label="* Dirección"
                                        multiline
                                        rows={3}
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        value={formik.values.info}
                                        InputLabelProps={{ shrink: true }}
                                        onChange={formik.handleChange}
                                        sx={{ mb: 2 }}
                                    />
                                </div>
                            )}

                            {/* Selector de pais */}
                            <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                                <FormControl fullWidth size="small" sx={{ mb: 1 }}>
                                    <InputLabel shrink id="region-select-label">* País</InputLabel>
                                    <Select
                                        labelId="region-select-label"
                                        value={selectedCountry}
                                        onChange={e => setSelectedCountry(e.target.value)}
                                        displayEmpty
                                        label="* País"
                                    >
                                        <MenuItem value=""><em>Seleccione un país</em></MenuItem>
                                        {filteredCountry
                                            .filter(country => !countriesSelected.some(c => c.id === country.id))
                                            .map(region => (
                                                <MenuItem key={region.id} value={region.id}>{region.name}</MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                                <Button
                                    variant="outlined"
                                    onClick={handleAddCountry}
                                    disabled={!selectedCountry}
                                    sx={{ mb: 1.5, alignSelf: "flex-end" }}
                                >
                                    Añadir
                                </Button>
                                {formik.errors.idCountry && (
                                    <p className="text-100 text-danger mt-1">
                                        {formik.errors.idCountry}
                                    </p>
                                )}
                            </div>

                            {/* Selector de regiones */}
                            <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                                <FormControl fullWidth size="small" sx={{ mb: 1 }} disabled={countriesSelected.length === 0}>
                                    <InputLabel shrink id="region-select-label">* Comunidad</InputLabel>
                                    <Select
                                        labelId="region-select-label"
                                        value={selectedRegion}
                                        onChange={e => setSelectedRegion(e.target.value)}
                                        displayEmpty
                                        label="* Comunidad"
                                    >
                                        <MenuItem value=""><em>Seleccione una comunidad</em></MenuItem>
                                        {filteredRegions
                                            .filter(region => !regionsSelected.some(r => r.id === region.id))
                                            .map(region => (
                                                <MenuItem key={region.id} value={region.id}>{region.name}</MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                                <Button
                                    variant="outlined"
                                    onClick={handleAddRegion}
                                    disabled={!selectedRegion}
                                    sx={{ mb: 1.5, alignSelf: "flex-end" }}
                                >
                                    Añadir
                                </Button>
                                {formik.errors.idRegion && (
                                    <p className="text-100 text-danger mt-1">
                                        {formik.errors.idRegion}
                                    </p>
                                )}
                            </div>

                            {/* Selector de provincias */}
                            <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                                <FormControl fullWidth size="small" sx={{ mb: 1 }} disabled={regionsSelected.length === 0}>
                                    <InputLabel shrink id="province-select-label">* Provincia</InputLabel>
                                    <Select
                                        labelId="province-select-label"
                                        value={selectedProvince}
                                        onChange={e => setSelectedProvince(e.target.value)}
                                        displayEmpty
                                        label="* Provincia"
                                    >
                                        <MenuItem value=""><em>Seleccione una provincia</em></MenuItem>
                                        {filteredProvinces
                                            .filter(province => !provincesSelected.some(p => p.id === province.id))
                                            .map(province => {
                                                const region = listRegion.find(r => r.id === province.idRegion);
                                                return (
                                                    <MenuItem key={province.id} value={province.id}>
                                                        {region ? `${region.name} - ${province.name}` : province.name}
                                                    </MenuItem>
                                                );
                                            })}
                                    </Select>
                                </FormControl>
                                <Button
                                    variant="outlined"
                                    onClick={handleAddProvince}
                                    disabled={!selectedProvince}
                                    sx={{ mb: 1.5, alignSelf: "flex-end" }}
                                >
                                    Añadir
                                </Button>
                                {formik.errors.idProvince && (
                                    <p className="text-100 text-danger mt-1">
                                        {formik.errors.idProvince}
                                    </p>
                                )}
                            </div>
                            {/* Selector de comarca */}
                            <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                                <FormControl fullWidth size="small" sx={{ mb: 1 }} disabled={provincesSelected.length === 0}>
                                    <InputLabel shrink id="municipality-select-label">* Comarca</InputLabel>
                                    <Select
                                        labelId="municipality-select-label"
                                        value={selectedComarca}
                                        onChange={e => setSelectedComarca(e.target.value)}
                                        displayEmpty
                                        label="* Comarca"
                                    >
                                        <MenuItem value=""><em>Seleccione una comarca</em></MenuItem>
                                        {filteredComarca
                                            .filter(comarca => !comarcasSelected.some(c => c.id === comarca.id))
                                            .map(comarca => {
                                                const province = listProvince.find(p => p.id === comarca.idProvince);
                                                const region = province ? listRegion.find(r => r.id === province.idRegion) : null;
                                                return (
                                                    <MenuItem key={comarca.id} value={comarca.id}>
                                                        {region && province
                                                            ? `${region.name} - ${province.name} - ${comarca.name}`
                                                            : comarca.name}
                                                    </MenuItem>
                                                );
                                            })}
                                    </Select>
                                </FormControl>
                                <Button
                                    variant="outlined"
                                    onClick={handleAddComarca}
                                    disabled={!selectedComarca}
                                    sx={{ mb: 1.5, alignSelf: "flex-end" }}
                                >
                                    Añadir
                                </Button>
                                {formik.errors.idComarca && (
                                    <p className="text-100 text-danger mt-1">
                                        {formik.errors.idComarca}
                                    </p>
                                )}
                            </div>
                            {/* Selector de municipios */}
                            <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                                <FormControl fullWidth size="small" sx={{ mb: 1 }} disabled={comarcasSelected.length === 0}>
                                    <InputLabel shrink id="municipality-select-label">* Población</InputLabel>
                                    <Select
                                        labelId="municipality-select-label"
                                        value={selectedMunicipality}
                                        onChange={e => setSelectedMunicipality(e.target.value)}
                                        displayEmpty
                                        label="* Población"
                                    >
                                        <MenuItem value=""><em>Seleccione una población</em></MenuItem>
                                        {filteredMunicipalities
                                            .filter(municipio => !municipalitiesSelected.some(m => m.id === municipio.id))
                                            .map(municipio => {
                                                const province = listProvince.find(p => p.id === municipio.idProvince);
                                                const region = province ? listRegion.find(r => r.id === province.idRegion) : null;
                                                return (
                                                    <MenuItem key={municipio.id} value={municipio.id}>
                                                        {region && province
                                                            ? `${region.name} - ${province.name} - ${municipio.name}`
                                                            : municipio.name}
                                                    </MenuItem>
                                                );
                                            })}
                                    </Select>
                                </FormControl>
                                <Button
                                    variant="outlined"
                                    onClick={handleAddMunicipality}
                                    disabled={!selectedMunicipality}
                                    sx={{ mb: 1.5, alignSelf: "flex-end" }}
                                >
                                    Añadir
                                </Button>
                                {formik.errors.idMunicipality && (
                                    <p className="text-100 text-danger mt-1">
                                        {formik.errors.idMunicipality}
                                    </p>
                                )}
                            </div>
                        </Grid>
                        <Grid item md={6}>
                            <div style={{ gap: "0px", display: "flex", flexDirection: "column" }}>
                                <div>
                                    <h3 className="p-0 mt-0">&nbsp;</h3>
                                </div>

                                {/* Pais */}
                                <label style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                    {/* Bolita de color pais */}
                                    <span
                                        style={{
                                            display: "inline-block",
                                            width: "12px",
                                            height: "12px",
                                            borderRadius: "50%",
                                            backgroundColor: "#a5cb1fff", // verde MUI para region
                                            marginRight: "4px"
                                        }}
                                    ></span>
                                    Países seleccionados
                                </label>
                                <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
                                    {countriesSelected.length === 0 ? (
                                        <Chip label="Ningún país seleccionado" variant="outlined" size="small" />
                                    ) : (
                                        countriesSelected.map(country => (
                                            <Chip
                                                key={country.id}
                                                label={
                                                    <span style={{
                                                        fontWeight: 500,
                                                        color: "#a5cb1fff" // azul MUI
                                                    }}>
                                                        {country.name}
                                                    </span>
                                                }
                                                onDelete={() => handleRemoveCountry(country.id)}
                                                color="default"
                                                size="small"
                                                sx={{ mb: 0.2 }}
                                                clickable
                                                variant="filled"
                                            />
                                        ))
                                    )}
                                </div>

                                {/* Comunidad */}
                                <label style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: 20 }}>
                                    {/* Bolita de color comunidades */}
                                    <span
                                        style={{
                                            display: "inline-block",
                                            width: "12px",
                                            height: "12px",
                                            borderRadius: "50%",
                                            backgroundColor: "#1976d2", // verde MUI para region
                                            marginRight: "4px"
                                        }}
                                    ></span>
                                    Comunidades seleccionadas
                                </label>
                                <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
                                    {regionsSelected.length === 0 ? (
                                        <Chip label="Ninguna comunidad seleccionada" variant="outlined" size="small" />
                                    ) : (
                                        regionsSelected.map(region => {
                                            const country = listCountry.find(r => r.id === region.idCountry);
                                            return (
                                                <Chip
                                                    key={region.id}
                                                    label={
                                                        <span>
                                                            <span style={{
                                                                fontWeight: 500,
                                                                color: "#a5cb1fff",
                                                                marginRight: "4px"
                                                            }}>
                                                                {country.name}
                                                            </span>
                                                           <span style={{
                                                                fontWeight: 500,
                                                                color: "#1976d2"
                                                            }}>
                                                                {region.name}
                                                            </span>
                                                        </span>
                                                    }
                                                    onDelete={() => handleRemoveRegion(region.id)}
                                                    color="default"
                                                    size="small"
                                                    sx={{ mb: 0.2 }}
                                                    clickable
                                                    variant="filled"
                                                />
                                            );
                                        })
                                    )}
                                </div>

                                {/* Provincia */}
                                <label style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: 20 }}>
                                    {/* Bolita de color provincias */}
                                    <span
                                        style={{
                                            display: "inline-block",
                                            width: "12px",
                                            height: "12px",
                                            borderRadius: "50%",
                                            backgroundColor: "#9c27b0", // lila MUI para provincias
                                            marginRight: "4px"
                                        }}
                                    ></span>
                                    Provincias seleccionadas
                                </label>
                                <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
                                    {provincesSelected.length === 0 ? (
                                        <Chip label="Ninguna provincia seleccionada" variant="outlined" size="small" />
                                    ) : (
                                        provincesSelected.map(province => {
                                            const region = listRegion.find(r => r.id === province.idRegion);
                                            const country = region ? listCountry.find(r => r.id === region.idCountry) : null;
                                            return (
                                                <Chip
                                                    key={province.id}
                                                    label={
                                                        <span>
                                                            <span style={{
                                                                fontWeight: 500,
                                                                color: "#a5cb1fff",
                                                                marginRight: "4px"
                                                            }}>
                                                                {country.name}
                                                            </span>
                                                            <span style={{
                                                                fontWeight: 500,
                                                                color: "#1976d2", // azul MUI
                                                                marginRight: "4px"
                                                            }}>
                                                                {region ? region.name : ""}
                                                            </span>
                                                            <span style={{
                                                                fontWeight: 500,
                                                                color: "#9c27b0" // lila MUI
                                                            }}>
                                                                {province.name}
                                                            </span>
                                                        </span>
                                                    }
                                                    onDelete={() => handleRemoveProvince(province.id)}
                                                    color="default"
                                                    size="small"
                                                    sx={{ mb: 0.2 }}
                                                    clickable
                                                    variant="filled"
                                                />
                                            );
                                        })
                                    )}
                                </div>

                                {/* Comarca */}
                                <label style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: 20 }}>
                                    {/* Bolita de color comarca */}
                                    <span
                                        style={{
                                            display: "inline-block",
                                            width: "12px",
                                            height: "12px",
                                            borderRadius: "50%",
                                            backgroundColor: "#388e3c",
                                            marginRight: "4px"
                                        }}
                                    ></span>
                                    Comarcas seleccionadas
                                </label>
                                <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
                                    {comarcasSelected.length === 0 ? (
                                        <Chip label="Ninguna comarca seleccionada" variant="outlined" size="small" />
                                    ) : (
                                        comarcasSelected.map(comarca => {
                                            const province = listProvince.find(p => p.id === comarca.idProvince);
                                            const region = province ? listRegion.find(r => r.id === province.idRegion) : null;
                                            const country = region ? listCountry.find(r => r.id === region.idCountry) : null;
                                            return (
                                                <Chip
                                                    key={comarca.id}
                                                    label={
                                                        <span>
                                                            <span style={{
                                                                fontWeight: 500,
                                                                color: "#a5cb1fff",
                                                                marginRight: "4px"
                                                            }}>
                                                                {country.name}
                                                            </span>
                                                            <span style={{
                                                                fontWeight: 500,
                                                                color: "#1976d2", // azul MUI
                                                                marginRight: "4px"
                                                            }}>
                                                                {region ? region.name : ""}
                                                            </span>
                                                            <span style={{
                                                                fontWeight: 500,
                                                                color: "#9c27b0", // lila MUI
                                                                marginRight: "4px"
                                                            }}>
                                                                {province ? province.name : ""}
                                                            </span>
                                                            <span style={{
                                                                fontWeight: 500,
                                                                color: "#388e3c" // verde MUI
                                                            }}>
                                                                {comarca.name}
                                                            </span>
                                                        </span>
                                                    }
                                                    onDelete={() => {handleRemoveComarca(comarca.id)}}
                                                    color="default"
                                                    size="small"
                                                    sx={{ mb: 0.2 }}
                                                    clickable
                                                    variant="filled"
                                                />
                                            );
                                        })
                                    )}
                                </div>

                                {/* Población */}
                                <label style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: 20 }}>
                                    {/* Bolita de color poblaciones */}
                                    <span
                                        style={{
                                            display: "inline-block",
                                            width: "12px",
                                            height: "12px",
                                            borderRadius: "50%",
                                            backgroundColor: "#000000", // azul MUI para poblaciones
                                            marginRight: "4px"
                                        }}
                                    ></span>
                                    Poblaciones seleccionadas
                                </label>
                                <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
                                    {municipalitiesSelected.length === 0 ? (
                                        <Chip label="Ninguna población seleccionada" variant="outlined" size="small" />
                                    ) : (
                                        municipalitiesSelected.map(municipio => {
                                            const province = listProvince.find(p => p.id === municipio.idProvince);
                                            const region = province ? listRegion.find(r => r.id === province.idRegion) : null;
                                            const country = region ? listCountry.find(r => r.id === region.idCountry) : null;
                                            const comunidad = municipio.comarcaName
                                            return (
                                                <Chip
                                                    key={municipio.id}
                                                    label={
                                                        <span>
                                                            <span style={{
                                                                fontWeight: 500,
                                                                color: "#a5cb1fff",
                                                                marginRight: "4px"
                                                            }}>
                                                                {country.name}
                                                            </span>
                                                            <span style={{
                                                                fontWeight: 500,
                                                                color: "#1976d2", // azul MUI
                                                                marginRight: "4px"
                                                            }}>
                                                                {region ? region.name : ""}
                                                            </span>
                                                            <span style={{
                                                                fontWeight: 500,
                                                                color: "#9c27b0", // lila MUI
                                                                marginRight: "4px"
                                                            }}>
                                                                {province ? province.name : ""}
                                                            </span>
                                                            <span style={{
                                                                fontWeight: 500,
                                                                color: "#388e3c", // verde MUI
                                                                marginRight: "4px"
                                                            }}>
                                                                {comunidad}
                                                            </span>
                                                            <span style={{
                                                                fontWeight: 500,
                                                                color: "#000000" // verde MUI
                                                            }}>
                                                                {municipio.name}
                                                            </span>
                                                        </span>
                                                    }
                                                    onDelete={() => handleRemoveMunicipality(municipio.id)}
                                                    color="default"
                                                    size="small"
                                                    sx={{ mb: 0.2 }}
                                                    clickable
                                                    variant="filled"
                                                />
                                            );
                                        })
                                    )}
                                </div>

                            </div>
                        </Grid>
                    </Grid>
                </Box>
            )}
        </>

    )
}
